export default "__VITE_ASSET__DYBzs0$o__"